export enum Status {
  IDLE = 'idle',
  LOADING = 'loading',
  REFRESHING = 'refreshing',
  ERROR = 'error',
  SUCCESS = 'success'
}
